<template>
  <section id="theme-selector" :class="[{'dark': isDarkMode}]">
    <h1>Select a Theme!</h1>
    <div id="available-themes">
      <div class="theme" v-for="theme in availableThemes" :class="[`theme-${theme}`, {selected: theme == selectedTheme}]" @click.prevent="selectTheme(theme)">
        <span class="regular-text">A</span>
        <span class="link">A</span>
      </div>
    </div>

    <button @click.prevent="toggleDarkMode" >Toggle Dark Mode</button>
    <button @click.prevent="closePanel" >Close Theme Panel</button>
  </section>
</template>


<script>
import axios from 'axios';

export default {
  name: 'ThemeSelector',

  data() {
    return {
      availableThemes: [
        'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i'
      ],
    }
  },

  computed: {
    isDarkMode() {
      return this.$store.state.loggedUserModel.info.darkmode;
    },

    selectedTheme() {
      return this.$store.state.loggedUserModel.info.theme
    }
  },

  methods: {
    selectTheme(theme) {
      this.$set(this.$store.state.loggedUserModel.info, 'theme', theme);
      this.saveTheme();
    },

    toggleDarkMode() {
      if (this.isDarkMode) {
        this.$set(this.$store.state.loggedUserModel.info, 'darkmode', false)
      } else {
        this.$set(this.$store.state.loggedUserModel.info, 'darkmode', true)
      }

      this.saveTheme();
    },

    saveTheme() {
      axios.post('api/member/saveTheme', {
        theme: this.selectedTheme,
        isDarkMode: this.isDarkMode
      }).then()
    },

    closePanel(){
      this.$emit('exitThemeSelectMode')
    }
  }
}
</script>


// WEBPACK FOOTER //
// ThemeSelector.vue?ff9745d6